import { Component, OnInit } from '@angular/core';
import { IMAGE, OFFER } from 'src/app/config';
import { ApiService } from 'src/app/api.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-offers',
    templateUrl: './offers.component.html',
    styleUrls: ['./offers.component.css'],
    
})
export class OffersComponent implements OnInit {
  data:any;
  image = IMAGE+'offer/';
  constructor(private api:ApiService,private router:Router) {
    this.api.Get(OFFER).then(data=>{
      this.data = data['data']['data'];
    }).catch(d=>{
      if( d.status == 503){
        this.api.onFail('Your session is expired please login again','Login');
        this.api.setGoto();
        this.api.setlogin(0);
        this.api.logout();
        setTimeout(() => {
        this.router.navigate(['/login']);
        },1000);
      } else{
        console.log(d);
      }});
   }

  ngOnInit(): void {
  }

}
